export const SET_ADDRESS_ERROR = 'SET_ADDRESS_ERROR';

export const setAddressError = () => ({
  type: SET_ADDRESS_ERROR,
});
